export default __webpack_public_path__ + "486e06ce18425bb1b6c1fcf0acefe02a.webp";